import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      '& .MuiSkeleton-root': {
        borderRadius: 8,
      },
    },
    wrapperCards: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gap: '2.5rem',
      marginBottom: '2.5rem',
    },
    wrapperCharts: {
      display: 'grid',
      gridTemplateColumns: '0.94fr 3fr',
      gap: '2.5rem',
      marginBottom: '2.5rem',
    },
  }),
)
